import React, { useState } from "react"
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useUser } from "../../../Hooks/useUser";
import axios from "../../../api/axios";

const TeamJoin = (props) => {
    const user = useUser();
    const params = useParams();
    const eventid = params.eventid;
    const { enqueueSnackbar } = useSnackbar();

    const [team, setTeam] = useState({
        BPEventID: parseInt(eventid),
        BPGroupName: '',
        BPGroupOwner: user?.user?.UserID,
        BPGroupSize: 0,
    });

    async function JoinTeam() {
        if (!team.BPGroupName.trim()) {
            enqueueSnackbar('Please enter a team name.');
            return;
        }

        try {
            const result = await axios.post('/api/groups/joingroup', {
                EventID: eventid,
                TeamName: team.BPGroupName,
            });

            // Log so you can verify the response shape matches what Register expects
            //console.log('JoinTeam response:', result.data);

            if (result.data) {
                // Merge API response with local state so BPGroupName is always
                // present even if the server returns a partial object
                const savedTeam = { ...team, ...result.data };
                setTeam(savedTeam);
                enqueueSnackbar('Team Found');
                props.onTeamReady(savedTeam); // send full merged object up to Register
            } else {
                enqueueSnackbar('Your Team Name did not match what we have in our system.');
            }
        } catch (err) {
            console.error('JoinTeam error:', err);
            if (err?.response?.status === 404) {
                enqueueSnackbar('Your Team Name did not match what we have in our system. Please double-check with your team leader.');
            } else {
                enqueueSnackbar('An error occurred while looking up the team. Please try again.');
            }
        }
    }

    function handleTeamInputChange(input) {
        const target = input.target;
        const value = target.value;
        const name = target.id;
        setTeam({ ...team, [name]: value });
    }

    return (
        <div className="mb-4">
            <div className="full-row gray px-4 py-3 mb-4 rounded">
                <h5 className="mb-0 text-uppercase">Team Information</h5>
            </div>
            <div className="px-4 pb-3">
                <p className="mb-3">Please enter the Team name below in order to join the Team.</p>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="required-caption">
                                <span className="required-field">*</span>Team Name
                            </label>
                            <input
                                id="BPGroupName"
                                type="text"
                                maxLength="200"
                                className="form-control"
                                placeholder="Enter team name"
                                value={team.BPGroupName}
                                onChange={handleTeamInputChange}
                            />
                            <small className="form-text text-muted">
                                Enter the team name used by the leader of this event in order to register
                            </small>
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-md-12">
                        <a
                            className="button-default button-green"
                            onClick={JoinTeam}
                            role="button"
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minHeight: '40px',
                                minWidth: '160px',
                                cursor: 'pointer',
                            }}
                        >
                            Join Team
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TeamJoin;